import styled, {css} from "styled-components"
import Button from "@irati/ui/src/Button"
import {Label} from "@irati/ui/src/Typography"

interface SelectorComponentProps {
  selected?: boolean
  iconBgColor?: string
  marginBottom?: number
}

export const SelectorComponent = styled(Button)<SelectorComponentProps>`
  ${({theme, selected}) => css`
    background-color: ${selected ? theme.colors.primary2 : "transparent"};
    border: 2px solid ${selected ? theme.colors.primary2 : theme.colors.primary2_50};
    border-radius: ${theme.spacing.one};
    color: ${selected ? theme.colors.utility.white : theme.colors.primary2};
    margin: 0 ${theme.spacing.one} ${theme.spacing.one} 0;
    padding: ${theme.spacing.one} ${theme.spacing.two};
    white-space: nowrap;
    &:focus {
      background-color: ${selected ? theme.colors.primary2 : theme.colors.utility.white};
      color: ${selected ? theme.colors.utility.white : theme.colors.primary2};
      ${Label} {
        color: ${selected ? theme.colors.utility.white : theme.colors.utility.ink};
      }
    }
    &:hover {
      ${Label} {
        color: ${selected ? theme.colors.utility.white : theme.colors.utility.ink};
      }
      background-color: ${selected ? theme.colors.primary2 : "transparent"};
      box-shadow: ${theme.shadows.low};
      color: ${selected ? theme.colors.utility.white : theme.colors.primary2};
    }
    ${theme.mediaQueries.minWidthMedia.tablet`
      padding: ${theme.spacing.oneAndHalf} ${theme.spacing.two};
    `}
    ${theme.mediaQueries.maxWidthMedia.tablet`
      width: 100%;
    `}
    span {
      justify-content: flex-start;
    }
    ${Label} {
      color: ${selected ? theme.colors.utility.white : theme.colors.utility.ink};
    }
  `}
`

export const BackgroundColorIcon = styled.div<SelectorComponentProps>`
  ${({theme, selected, iconBgColor, marginBottom = theme.spacing.two}) => css`
    background-color: ${selected ? iconBgColor : iconBgColor};
    border-radius: 50%;
    width: 50px;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: ${marginBottom};
  `}
`
